// Early execution to prevent flicker
(function() {
  var hasClosedPopup = localStorage.getItem("hasClosedNewsletterPopup");
  if (hasClosedPopup) {
    var style = document.createElement('style');
    style.innerHTML = '.popup.help-popup { display: none !important; }';
    document.head.appendChild(style);
  }
})();
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".popup.help-popup");
  const closeBtn = document.querySelector(".close-popup");

  const hasClosedPopup = localStorage.getItem("hasClosedNewsletterPopup");

  if (!hasClosedPopup && popup) {
    popup.style.display = "flex";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (popup) popup.style.display = "none";
      localStorage.setItem("hasClosedNewsletterPopup", "true");
    });
  }
});